import { atom } from 'jotai'

/**
 * When set to a task ID, the manual task processor modal will be displayed.
 * Set to null to close the modal.
 */
export const manualTaskProcessorTaskIdAtom = atom<string | null>(null)

export type WatchtowerFilterType = 'status' | 'trigger'

export const NOTIFICATIONS_FILTER_VALUE = 'NOTIFICATIONS'

export const watchtowerFiltersAtom = atom<
  Record<WatchtowerFilterType, string[]>
>({
  status: [],
  trigger: []
})

/**
 * Maps trigger filter values (used in execution queries) to manual task
 * review type values (used in manual task queries).
 */
const TRIGGER_TO_REVIEW_TYPE: Record<string, string> = {
  QUOTE_REQUIRES_APPROVAL: 'QUOTE_APPROVAL',
  CONTRACT_UPLOADED: 'CONTRACT_REVIEW',
  INVOICE_SENT: 'REVIEW_EMAIL'
}

/**
 * Converts the shared trigger filter values into the corresponding
 * manual task review type values for the manual task API.
 */
export const mapTriggerToReviewType = (triggers: string[]): string[] =>
  triggers.map(t => TRIGGER_TO_REVIEW_TYPE[t]).filter(Boolean)

/**
 * Maps execution status filter values to the equivalent manual task statuses.
 * Returns undefined (no filter) when no status filters are active,
 * or null when the selected statuses have no manual task equivalent.
 */
const EXECUTION_TO_MANUAL_TASK_STATUS: Record<string, string | null> = {
  RUNNING: 'PENDING',
  COMPLETED: 'COMPLETED',
  TERMINATED: 'CANCELLED',
  FAILED: null
}

export const mapExecutionStatusToManualTaskStatus = (
  executionStatuses: string[]
): string | undefined | null => {
  if (executionStatuses.length === 0) return undefined

  const mappedStatuses = executionStatuses
    .map(s => EXECUTION_TO_MANUAL_TASK_STATUS[s])
    .filter((s): s is string => s !== null)

  if (mappedStatuses.length === 0) return null
  return mappedStatuses.join(',')
}
